"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.analysis = analysis;
exports.questions = void 0;
var questions = [{
  prompt: "",
  extraText: "What is the worst thing that could happen?",
  placeholder: "Write your predictive thought here…",
  tips: "TIPS: You can use a format like this \u201CI will _______ (bad thing)\u201D or \u201CHe/she/it will ______ (bad thing)\u201D or \u201CUnless I ______ then _______ (bad thing) will happen\u201D",
  type: "multirow",
  aggregated: true
}, {
  prompt: "",
  extraText: "How likely is it that the worst thing will happen?",
  placeholder: "Write how unlikely it is and the reasons why it’s unlikely to happen here...",
  tips: "TIPS: The more reasons you can find why the it\u2019s unlikely to happen, the more effective this exercise will be. How could the situation change so that it\u2019s less likely? What are your strengths and how could they make it less likely? ",
  type: "multirow",
  aggregated: true
}, {
  prompt: "",
  extraText: "Have I been convinced something bad would happen but it never came true? ",
  placeholder: "Write something that you predicted would turn out badly but it turned out ok here...",
  tips: "TIPS: You can use a similar situation or something entirely different. The goal is to write about something that helps you remember that you are probably stuck in negatively biased thinking right now. ",
  type: "multirow",
  aggregated: true
}, {
  prompt: "",
  extraText: "Is it likely that this situation will work out like past situations?",
  placeholder: "Write a better way here to think about this here...",
  tips: "TIPS: This can be new, positive and helpful thought to replace your old mindset about this situation. Or write a one sentence summary of your answers to the previous questions. ",
  type: "multirow",
  aggregated: true
}, {
  prompt: "",
  extraText: "What is the next thought you need to retrain?",
  placeholder: "Write down any reasons why the thought still feels true here...",
  type: "multirow",
  tips: "TIPS: It’s normal to retrain a thought but it still feels partly true. That’s because there are related thoughts that need to be trained. Unhelpful thoughts occur in clusters of related thoughts that make up a belief system. To identify the next thought in the cluster, ask yourself: Why does my unhelpful thought still feel true? Write down any reasons you think of. These unhelpful thoughts are the next ones that you’ll need to retrain to change your mindset.",
  aggregated: true
}];
exports.questions = questions;

function analysis(answers) {
  return {
    answers: answers.slice(0, 4),
    rootThought: answers[4]
  };
}

;